import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">HOW CAN I IMPROVE MY ACTIVE LISTENING SKILLS
</span></div>
                                        </div>
                                        <p style={{paddingBottom:'8px !important'}}>It’s relatively easy to manage
                                            or resolve the tangible, physical or environmental barriers, but
                                            more difficult to deal with internal ones. However, preparing
                                            adequately for discussions and meetings will do much to overcome
                                            them.</p>
                                        <p style={{paddingBottom:'15px !important'}}>Here are some ‘active
                                            listening’ techniques, based on the three elements of the listening
                                            process we mentioned at the start – hearing, interpreting and
                                            contextualising.</p>
                                        <div className="border_subtitle">Hearing and interpreting</div>
                                        <ul className="greenbullet-list">
                                            <li>First of all, stop talking, or at least pause to invite the
                                                other person to speak!
                                            </li>
                                            <li>Eliminate as many distractions as possible, both external and
                                                internal.
                                            </li>
                                            <li>Control your own non-verbal signals to the speaker. Pay
                                                attention to how you’re standing or sitting, your eye contact
                                                and small encouragements like nodding, smiling and mirroring the
                                                speaker’s own body language (obviously, this doesn’t mean
                                                behaving like a budgie with a mirror – just adopt an empathetic
                                                or complementary attitude). Be discreet, too, about eye contact
                                                – while it’s important to appear open and receptive, take care
                                                not to look as if you’re staring or appearing inquisitorial!
                                                (It’s as well, too, to note that interpretation of eye contact
                                                varies amongst cultures.)
                                            </li>
                                        </ul>
                                        <div className="browncontentbg uiheading keyquestionpad"><p>Research has
                                            shown that we can put a lot more emphasis on body language (55%) or
                                            tone of voice (38%) than on the actual words (7%) when we are
                                            interpreting ambiguous messages. That means that HOW something is
                                            said, and HOW speakers hold themselves can reveal more than WHAT
                                            they say.<a className="superscripttext"
                                                        href="further_info.php?course=300"><sup>6</sup></a></p>
                                        </div>
                                        <br/>

                                            <div className="border_subtitle">Understanding</div>
                                            <ul className="greenbullet-list">
                                                <li>Make sure you understand the purpose of the speaker, and
                                                    also be aware of what you want from the conversation.
                                                </li>
                                                <li>Ask questions (without interrupting) and use notes you have
                                                    written to remind you what needs clarifying.
                                                </li>
                                                <li>You can also try ‘reflecting’. This is used a lot by sales
                                                    professionals. What we say can be separated into three types
                                                    of information – facts, thoughts (or beliefs) and feelings
                                                    (or emotions). ‘Reflecting’ means repeating back to someone
                                                    what they have said (or suggested) to check or demonstrate
                                                    that you have understood. You can ‘reflect’ emotions, too,
                                                    for example: ‘….so, this has left you feeling confused?’
                                                </li>
                                                <li>Take notes. Write down key words and phrases to jog your
                                                    memory later.
                                                </li>
                                                <li>Summarise or paraphrase what you understand to be the facts
                                                    you’re given; for example,<span className="subtiltereg"> ‘As I understand it, what you’re saying is....’</span> or<span
                                                        className="subtiltereg"> ‘So your point is that....’ </span>This
                                                    gives you both an opportunity to verify or correct
                                                    understanding.
                                                </li>
                                                <div className="browncontentbg uiheading keyquestionpad"
                                                     style={{marginTop: '15px'}}><p>Practise being a good
                                                    listener at any opportunity, in a shop, over dinner or with
                                                    friends.</p></div>
                                                <br/>
                                                    <li>Share thoughts or beliefs that you have heard, and try
                                                        to convey the underlying feelings or emotions which you
                                                        believe are involved. For example, the speaker may be
                                                        very upset and wants you to display empathy or sympathy
                                                        with their situation. It is this reflection of thought
                                                        and feelings which distinguishes reflecting from just
                                                        parroting back to the speaker, which might get a bit
                                                        tedious and annoying for all concerned.
                                                    </li>

                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }